import { useQuery } from '@tanstack/react-query';
import { getScreensMeta } from 'shared/src/api';
import { useGetCommonParams } from '../../hooks';
import { useFilterListAtom } from 'shared/src/component/AtomicRenderer/ItemList/FilterList/Provider/filterList/useFilterListAtom';

export const useGetScreensMetaQuery = () => {
  const { screenName: routeScreenName, nextToken } = useGetCommonParams();
  const {
    filterListAtomValue: { screen_name },
  } = useFilterListAtom();

  // 웹에서 이전 화면의 stale atom으로 API 호출 방지
  const isAtomSynced = screen_name === routeScreenName;

  return useQuery({
    queryKey: ['getScreensMeta', { screen_name: routeScreenName, nextToken }],
    queryFn: () =>
      getScreensMeta({
        screen: routeScreenName!,
        next_token: nextToken ?? undefined,
      }),
    enabled: routeScreenName !== undefined && isAtomSynced,
  });
};
